import gql from 'graphql-tag';

export const GOOGLE_SIGN_IN_MUTATION = gql`
    mutation socialSignInGoogle($accessToken: String!) {
        socialSignInGoogle(accessToken: $accessToken) {
            success
        }
    }
`;
